<template>
  <div :class="`ekt-menu ${isQidian?'qidian':''}`">
    <!-- 主菜单 -->
    <div class="ekt-menu-bar scroll-bar-y">
      <div class="ekt-menu-top">
        <div class="inner-box scroll-bar-y">
          <template v-for="main in getTopMenu">
            <el-popover
              :key="main.menuKey"
              placement="right-start"
              popper-class="ekt-menu-top-popover"
              trigger="hover"
              :disabled="!main.sub_menu"
              :visible-arrow="false"
              :offset="6"
            >
              <MainMenuItem slot="reference" :menu="main" :active="mainMenuKey == main.menuKey || appMenuKey == main.menuKey"
                @click.native="!main.sub_menu && clickMainMenu(main.menuKey)" />
              <div class="main-sub-menu" v-if="main.sub_menu">
                <SubMenuItem v-for="subItem in main.sub_menu" :key="subItem.menuKey" :menu="subItem" :active="mainMenuKey == subItem.menuKey"
                @click.native="clickMainMenu(subItem.menuKey)" />
              </div>
            </el-popover>
          </template>
        </div>
      </div>
      <div class="ekt-menu-bottom" v-if="getBottomMenu.length > 0">
        <div class="inner-box scroll-bar-y">
          <template v-for="main in getBottomMenu">
            <MainMenuItem :key="main.menuKey" :menu="main" :active="mainMenuKey == main.menuKey"
              @click.native="clickMainMenu(main.menuKey)" />
          </template>
        </div>
      </div>
    </div>
    <div class="menu-content">
      <!-- 二级、三级菜单 -->
      <template v-if="!hasThdMenu">
        <div class="menu-content-title">
          {{ mainMenuTitle }}
          <span v-if="subMenu.length > 0 && toggleIcon" class="title-menu">
            <!-- 只有新工单才有刷新按钮 -->
            <el-tooltip v-show="['client', 'ticket-v4', 'custom', 'ticket','aikms'].includes(subMenuKey)" effect="dark"
              :content="$t('common.refresh')" placement="top">
              <img v-if="loading" class="loading" :src="loadingSrc"></img>
              <i v-else class="iconfont icon-shuaxin-line" @click="refreshEvents(subMenuKey, true)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="menuOpenedInfo.text" placement="top">
              <i :class="['iconfont', menuOpenedInfo.icon]" @click="toggleMenuOpened"></i>
            </el-tooltip>
          </span>
        </div>
        <div class="menu-content-wrapper">
          <div class="scroll-bar-y" ref="menuScroll">
            <el-menu :default-active="subActive.key || ''" :default-openeds="[...openedMenuKeys]" class="menu-component"
              @select="selectMenu" @close="closeMenu" @open="openMenu">
              <template v-for="sub in subMenu">
                <template v-if="hasChildrenMenu(sub)">
                  <el-submenu class="menu-level-2" :key="sub.menuKey" :index="sub.menuKey">
                    <template slot="title">
                      <span class="_menu-title _menu-label _menu-title-level-2">
                        <div class="menu-icon" v-if="sub.logo_type === 1" :style="{backgroundColor: sub.logo.split(',')[0]}">
                          <i :class="['iconfont', sub.logo.split(',')[1]]"></i>
                        </div>
                        <div class="menu-icon" v-else-if="sub.logo_type === 2">
                          <img :src="sub.logo" />
                        </div>
                        <i v-else :class="['iconfont', sub.icon || 'icon-wenjian-line']"></i>
                        <span :title="sub.name" class="ellipsis-inline sub-name _menu-label-name">{{ sub.name }}</span>
                        <HotOrNewVue :menu="sub" />
                        <span v-if="showStatistics(sub)" class="statictics_count">
                          {{ `${statisticsData[sub.menuKey] || 0}` }}
                        </span>
                      </span>
                    </template>
                    <template v-for="thd in sub.children">
                      <template v-if="hasChildrenMenu(thd) && thd.type != 'submenu'">
                        <el-submenu class="menu-level-3" :key="thd.menuKey" :index="thd.menuKey">
                          <template slot="title">
                            <span class="_menu-title _menu-label">
                              <i :class="['iconfont', thd.icon]"></i>
                              <span :title="thd.name" class="_menu-label-name">{{ thd.name }}</span>
                              <HotOrNewVue :menu="thd" />
                              <span v-if="showStatistics(thd)" class="statictics_count">
                                {{ `${statisticsData[thd.menuKey] || 0}` }}
                              </span>
                            </span>
                          </template>
                          <el-menu-item v-for="four in thd.children" class="menu-level-4" :key="four.menuKey"
                            :index="four.menuKey">
                            <span class="_menu-title">
                              {{ four.name }}
                              <HotOrNewVue :menu="four" />
                            </span>
                          </el-menu-item>
                        </el-submenu>
                      </template>
                      <template v-else>
                        <el-menu-item class="menu-level-3" :key="thd.menuKey" :index="thd.menuKey">
                          <span class="_menu-title _menu-label">
                            <i v-if="thd.icon" :class="['iconfont', thd.icon]"></i>
                            <span :title="thd.name" class="_menu-label-name">{{ thd.name }}</span>
                            <HotOrNewVue :menu="thd" />
                            <span v-if="showStatistics(thd)" class="statictics_count">
                              {{ `${statisticsData[thd.menuKey] || 0}` }}
                            </span>
                          </span>
                          <i v-if="thd.type == 'submenu'" class="el-icon-arrow-right" style="
                              position: absolute;
                              top: 14px;
                              right: 8px;
                              font-size: 12px;
                            "></i>
                        </el-menu-item>
                      </template>
                    </template>
                  </el-submenu>
                </template>
                <template v-else>
                  <el-menu-item class="menu-level-2" :key="sub.menuKey" :index="sub.menuKey">
                    <span class="_menu-title _menu-label">
                      <i :class="['iconfont', sub.icon ]"></i>
                      <span :title="sub.name" class="_menu-label-name">{{ sub.name }}</span>
                      <HotOrNewVue :menu="sub" />
                      <span v-if="showStatistics(sub)" class="statictics_count">
                        {{ `${statisticsData[sub.menuKey] || 0}` }}
                      </span>
                    </span>
                  </el-menu-item>
                </template>
              </template>
            </el-menu>
          </div>
        </div>
      </template>
      <!-- 四级、五级菜单 -->
      <template v-else>
        <div class="menu-content-title back">
          <span style="cursor: pointer" @click="clearThdMenu">
            <i class="el-icon-arrow-left"></i>{{ $t('menu.backToPrevious') }}
          </span>
        </div>
        <div class="menu-content-wrapper">
          <div class="scroll-bar-y">
            <el-menu :default-active="thdActive.key || ''" :default-openeds="getThdMenuKeys" class="menu-component"
              @select="selectThdMenu">
              <template v-for="thd in thdMenu">
                <template v-if="hasChildrenMenu(thd)">
                  <el-submenu class="menu-level-2" :key="thd.menuKey" :index="thd.menuKey">
                    <template slot="title">
                      <span slot="title" class="_menu-label">
                        <i v-if="thd.icon" :class="['iconfont', thd.icon]"></i>
                        <span :title="thd.name" class="_menu-label-name">{{ thd.name }}</span>
                        <span v-if="showStatistics(thd)" class="statictics_count">
                          {{ `${statisticsData[thd.menuKey] || 0}` }}
                        </span>
                      </span>
                    </template>
                    <el-menu-item v-for="menu in thd.children" class="menu-level-3 _menu-label" :key="menu.menuKey"
                      :index="menu.menuKey">
                      <i v-if="menu.icon" :class="['iconfont', menu.icon]"></i>
                      <span :title="menu.name" class="_menu-label-name">{{ menu.name }}</span>
                      <span v-if="showStatistics(menu)" class="statictics_count">
                        {{ `${statisticsData[menu.menuKey] || 0}` }}
                      </span>
                    </el-menu-item>
                  </el-submenu>
                </template>
                <template v-else>
                  <el-menu-item class="menu-level-2 _menu-label" :key="thd.menuKey" :index="thd.menuKey">
                    <i v-if="thd.icon" :class="['iconfont', thd.icon]"></i>
                    <span :title="thd.name" class="_menu-label-name">{{ thd.name }}</span>
                    <span v-if="showStatistics(thd)" class="statictics_count">
                      {{ `${statisticsData[thd.menuKey] || 0}` }}
                    </span>
                  </el-menu-item>
                </template>
              </template>
            </el-menu>
          </div>
        </div>
      </template>
    </div>

    <span v-if="subMenu.length > 0" class="menu-collapse-btn" @click="toggleMenu">
      <i :class="[
            'menu-shouqi-bg',
            'iconfont',
            toggleIcon ? 'icon-shuangzuo-line' : 'icon-shuangyou-line',
          ]"></i>
    </span>
  </div>
</template>

<script type="">
import { mapActions, mapState } from "vuex";
import { getMenu } from "@/api/index";
import { loopMenu, returnMenuKeys } from "@/utils/index";
import service from "@/assets/js/request";
import MainMenuItem from "./mainItem/index.vue";
import SubMenuItem from "./subItem/index.vue";
import HotOrNewVue from './HotOrNew.vue';
import loadingPNG from '@/assets/images/loading.png'
export default {
  name: "Menu",
  components: {
    MainMenuItem,
    SubMenuItem,
    HotOrNewVue
  },
  props: {
    iframeIframe: null,
    isAdminPage: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      openedMenuKeys: [],

      // 主菜单
      mainMenu: [],
      mainMenuKey: "",
      // 二级菜单数据
      menuOpenedFlag: true,
      subMenu: [],
      subActive: {
        key: "",
        path: [],
      },

      // 三级菜单数据
      thdMenu: [],
      thdActive: {
        key: "",
        path: [],
      },

      toggleIcon: true,
      flag: 1,
      subMenuKey: '',
      loading: false,
      loadingSrc: loadingPNG,

      refreshCountTimer: null, // 统计定时器
      statisticsData: {} // 统计数据
    };
  },
  created() {
    // 查询菜单
    this.queryMenuData();
    // 监听点击tab
    this._Bus.$on("clickTab", (tab) => {
      const {
        mainMenuKey = "",
        subActive = { key: "", path: [] },
        thdActive = { key: "", path: [] },
      } = tab || {};
      this.subActive = subActive;
      this.thdActive = thdActive;

      this.$nextTick(() => {
        mainMenuKey && this.clickMainMenu(mainMenuKey, true);
      });
    });
  },
  beforeDestroy(){
    if(this.refreshCountTimer){
      clearInterval(this.refreshCountTimer)
      this.refreshCountTimer = null
    }
  },
  computed: {
    ...mapState(['rawMenuData']),
    appMenuKey() { // 应用悬浮菜单选中时
      const menu = this.mainMenu.find(v => v.sub_menu && v.sub_menu.some(v => v.menuKey === this.mainMenuKey))
      return menu ? menu.menuKey : ''
    },
    // 菜单模块标题
    mainMenuTitle() {
      const { mainMenu = [], mainMenuKey = "" } = this;
      let menu = this.getMenuByKey(mainMenu, mainMenuKey);

      if (mainMenuKey) {
        return menu.name;
      }

      return "";
    },
    menuOpenedInfo() {
      let flag = this.menuOpenedFlag;
      return {
        icon: flag ? "icon-shuangshang-line" : "icon-shuangxia-line",
        text: flag ? this.$t('menu.collapseAll') : this.$t('menu.expandAll'),
      };
    },
    // 顶部菜单
    getTopMenu() {
      return this.mainMenu.filter((menu) => menu.position !== "bottom") || [];
    },
    // 底部菜单
    getBottomMenu() {
      return this.mainMenu.filter((menu) => menu.position === "bottom") || [];
    },
    // 获取四级菜单的key
    getThdMenuKeys() {
      if (Array.isArray(this.thdMenu)) {
        return this.thdMenu.map((menu) => menu.menuKey);
      }
      return [];
    },
    // 判断模块是否有子菜单
    hasChildrenMenu() {
      return (menu) => {
        const { children = [] } = menu || {};
        if (children && Array.isArray(children)) {
          return !!children.length;
        }
        return false;
      };
    },
    hasThdMenu() {
      if (this.thdMenu.length > 0) {
        return true;
      }
      return false;
    },
    // 是否显示统计
    showStatistics() {
      return (menu) => {
        if(['ticket-v4'].includes(this.mainMenuKey)) {
          const ticketV4_menus = this.rawMenuData[this.mainMenuKey];
          const statistics = ticketV4_menus && ticketV4_menus.statistics
          if (statistics && statistics.enable && this.statisticsData[menu.menuKey] !== undefined) {
            return true
          }
        }
        return false;
      };
    },
    isQidian() {
      return this.isAdminPage != -1
    }
  },
  watch: {
    mainMenuKey: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal == 'ticket-v4') {
          this.refreshCount(newVal)
        } else {
          clearInterval(this.refreshCountTimer)
          this.refreshCountTimer = null
        }
      }
    }
  },
  methods: {
    ...mapActions(["addTab", "setRawMenuData", "changeActiveTabKey"]),
    refreshEvents(app_code, isClick) {
      this.loading = true
      getMenu({ app_code }).then(res => {
        if (res.code == 0) {
          let newMenu = { ...this.rawMenuData, [app_code]: res.data }
          this.setRawMenuData(newMenu)
          this.mainMenu = loopMenu(newMenu);

          this.$store.dispatch("setMenuList", this.mainMenu);
          let currMenu = this.getMenuByKey(this.mainMenu, app_code);
          if (this.subMenuKey == app_code) {
            this.subMenu = currMenu.children || [];
          }
        }
      }).finally(() => {
        this.loading = false
        if(isClick) {
          this.refreshCount(app_code)
        }
      })
    },
    /**
     * 功能：查询主菜单数据，并进行初始化
     */
    queryMenuData() {
      getMenu()
        .then((res) => {
          const { code = 0, data = {} } = res;
          if (code == 0) {
            // this.filterQidianMenu(data)
            // 菜单排序及对象转数组
            this.setRawMenuData(data)
            this.mainMenu = loopMenu(data);
            this.$store.dispatch("setMenuList", this.mainMenu);
            this.$nextTick(() => {
              this.clickMainMenu();
            });
          } else {
            console.log(this.$t('menu.getMenuFailed'));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterQidianMenu(data) {
      if(!this.isQidian) return;
      if(data) {
        if(this.isAdminPage == 1) {
          const filterKeys = ['settings', 'statistics', 'monitor', 'finance', 'qc']
          Object.keys(data).forEach(k => {
            if(!filterKeys.includes(k)) {
              delete data[k]
            }
          })
        } else {
          const filterKeys = ['settings', 'statistics', 'monitor', 'finance', 'qc']
          Object.keys(data).forEach(k => {
            if(filterKeys.includes(k)) {
              delete data[k]
            }
          })
        }
      }
    },
    /**
     * 功能：切换菜单模块
     * menukey：菜单模块key，如果为空，则取第一个模块
     * 备注：如果是点击Tab，直接重新初始当前选择的菜单，否则根据menuKey的情况判断是否初始化
     */
    clickMainMenu(menuKey = "", isClickTab = false) {
      if (this.$refs.menuScroll) {
        this.$refs.menuScroll.scrollTop = 0;
      }
      if (this.mainMenu.length == 0) {
          this.changeActiveTabKey(this._config.HOME_PAGE_KEY);
          console.log(this.$t('menu.noMenuPermission'));
        return;
      }

      if (!menuKey) {
        this.changeActiveTabKey(this._config.HOME_PAGE_KEY);
      }

      if (!isClickTab) {
        this.subMenu = [];
        this.subActive = { key: "", path: [] };
        this.thdMenu = [];
        this.thdActive = { key: "", path: [] };
      }

      this.flag = 1;
      this.menuOpenedFlag = true;
      let currMenu = this.getMenuByKey(this.mainMenu, menuKey);

      if (this.mainMenuKey != menuKey) {
        if (currMenu.children && currMenu.count <= 26) {
          this.openedMenuKeys = currMenu.children.filter(child => {
            return !!child.children
          }).map(child => child.menuKey);
        } else if (currMenu.children && currMenu.children[0].children) {
          this.openedMenuKeys = [currMenu.children[0].menuKey];
        }
      }
      if (isClickTab) {
        let path = [...this.subActive.path];
        path.pop();
        let openedSet = new Set([...this.openedMenuKeys, ...path]);
        this.openedMenuKeys = Array.from(openedSet);
      }

      this.mainMenuKey = currMenu.menuKey;
      this.subMenu = currMenu.children || [];
      this.subMenuKey = menuKey || ''
      if (['client', 'ticket-v4', 'custom', 'ticket', 'aikms'].includes(menuKey)) {
        this.refreshEvents(menuKey)
      }
      /**
       *  2、判断是否有subMenu: 主菜单是否有下级菜单，
       *    if(有下级){
       *      有下一级，菜单展开
       *    }else{
       *      没有下一级，类似“会话”主菜单
       *    }
       */
      if (this.subMenu.length > 0) {
        this.toggleIcon = true;
        this.$emit("toggleMenu", false);
      } else {
        this.toggleIcon = false;
        this.$emit("toggleMenu", true);

        const {
          menuKey,
          name,
          url,
          helpUrl,
          refresh = true,
          action = "",
        } = currMenu || {};
        // 框架自带tab页
        if(['cc_workbench'].includes(menuKey)) {
          this.addTab({
            mainMenuKey: this.mainMenuKey,
            key: menuKey,
            name: name,
            url: url,
            refresh
          });
        } else if (url) {
          if (action == "openBlank") {
            window.open(url);
          } else {
            this.addTab({
              mainMenuKey: this.mainMenuKey,
              key: menuKey,
              name: name,
              url: url,
              fullPath: [this.mainMenuKey],
              helpUrl,
              refresh,
            });
          }
        }
      }

      // 3、生成thdMenu数据
      if (this.thdActive.key) {
        let indexPath = this.subActive.path || [];
        let menus = this.subMenu || [];
        for (let index in indexPath) {
          let key = indexPath[index];
          menus = this.getMenuByKey(menus, key);
          if (menus.children) {
            menus = menus.children;
          }
        }

        this.thdMenu = menus;
      } else {
        this.thdMenu = [];
      }
    },
    // 关闭菜单处理
    closeMenu(key, keyPath) {
      let openedSet = new Set(this.openedMenuKeys);

      let targetMenu = null;
      keyPath.map((key, idx) => {
        if (idx == 0) {
          targetMenu = this.subMenu.filter((menu) => menu.menuKey == key)[0];
        } else {
          targetMenu = targetMenu.children.filter((menu) => menu.menuKey == key)[0]
        }
      });
      let menuKeys = returnMenuKeys(targetMenu);

      menuKeys.map((key) => openedSet.delete(key));

      this.openedMenuKeys = Array.from(openedSet) || [];
    },
    // 展开菜单处理
    openMenu(key, keyPath) {
      let keyLen = keyPath.length;
      let openedSet = new Set(this.openedMenuKeys);
      openedSet.add(key);
      if (keyLen == 1) {
        let targetMenu = this.subMenu.filter((menu) => menu.menuKey == key)[0];
        if (targetMenu && Array.isArray(targetMenu.children)) {
          let firstChild = targetMenu.children[0];
          if (firstChild.children) {
            openedSet.add(firstChild.menuKey);
          }
        }
      }

      this.openedMenuKeys = Array.from(openedSet) || [];
    },
    /**
     * 根据key查找菜单，如果没有找到，返回第一个菜单
     */
    getMenuByKey(menuData, key) {
      let menu = null
      menuData.some(menuItem => {
        if(menuItem.menuKey === key) {
          return menu = menuItem
        } else {
          if(menuItem.sub_menu) {
            menuItem.sub_menu.some(v => {
              if(v.menuKey === key) {
                return menu = v
              }
            })
          }
        }
      })
      if (menu) {
        return menu;
      } else {
        return this.getTopMenu[0] || this.getBottomMenu[0];
      }
    },
    toggleMenuOpened() {
      this.flag = this.flag + 1;
      if (this.menuOpenedFlag) {
        this.openedMenuKeys = []
      } else {
        this.openedMenuKeys = returnMenuKeys(this.subMenu)
      }
      this.menuOpenedFlag = !this.menuOpenedFlag;
    },
    /**
     * 功能：左右展开收起菜单
     */
    toggleMenu() {
      if (this.subMenu.length > 0) {
        this.toggleIcon = !this.toggleIcon;
        this.$emit("toggleMenu");
      }
    },
    /**
     * 功能：点击菜单，打开相应的页面
     */
    selectMenu(val, indexPath) {
      let menuItem = this.subMenu || [];
      let len = indexPath.length;
      let type = "";
      for (let index in indexPath) {
        let key = indexPath[index];
        menuItem = this.getMenuByKey(menuItem, key);
        if (menuItem.children) {
          type = menuItem.type;
          menuItem = menuItem.children;
        }
      }
      this.subActive = {
        key: val,
        path: indexPath || [],
      };
      if (menuItem) {
        if (type == "submenu") {
          this.thdMenu = menuItem;
        } else {
          const { refresh = true } = menuItem || {};
          menuItem.key = menuItem.menuKey;
          menuItem.mainMenuKey = this.mainMenuKey;
          menuItem.subActive = this.subActive;
          menuItem.fullPath = [this.mainMenuKey, ...this.subActive.path]
          if (menuItem.subActive)
            menuItem.refresh = refresh;
          if (menuItem.action == "openBlank") {
            window.open(menuItem.url);
          } else {
            this.addTab({ ...menuItem });
          }
        }
      }
    },

    // 关于四级菜单的选择
    selectThdMenu(val, indexPath) {
      let menuItem = this.thdMenu || [];
      for (let index in indexPath) {
        let key = indexPath[index];
        menuItem = this.getMenuByKey(menuItem, key);
        if (menuItem.children) {
          menuItem = menuItem.children;
        }
      }
      this.thdActive = {
        key: val,
        path: indexPath || [],
      };

      if (menuItem) {
        const { refresh = true } = menuItem || {};
        menuItem.tag = String(val);
        menuItem.mainMenuKey = this.mainMenuKey;
        menuItem.subActive = this.subActive;
        menuItem.thdActive = this.thdActive;
        menuItem.key = menuItem.menuKey;
        menuItem.refresh = refresh;
        menuItem.fullPath = [this.mainMenuKey, ...menuItem.subActive.path, ...menuItem.thdActive.path]
        if (menuItem.action == "openBlank") {
          window.open(menuItem.url);
        } else {
          this.addTab({ ...menuItem });
        }
      }
    },

    clearThdMenu() {
      this.thdMenu = [];
    },

    /**
     * 功能：处理当前模块菜单中的定时统计数据
     */
    fetchMenuCount(mainMenu) {
      function deepHandle(arr) {
        arr.forEach((item) => {
          if (
            item.statistics &&
            item.statistics.enable &&
            item.statistics.url
          ) {
            let timer_count =
              Number(item.statistics.interval) * 60 * 1000 || 10000;
            item.statistics_count = 0;
            (function (_item) {
              let url = _item.statistics.url;
              let ids = [_item.tag];
              setInterval(() => {
                service({
                  url: url,
                  method: "get",
                  params: {
                    ids: ids,
                  },
                })
                  .then((res) => {
                    _item.statistics_count = res.data;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }, timer_count);
            })(item);
          }
          if (
            item.children &&
            Array.isArray(item.children) &&
            item.children.length > 0
          ) {
            deepHandle(item.children);
          }
        });
      }
      deepHandle(mainMenu);
      this.mainMenu = mainMenu;
    },
    refreshCount(app_code) {
      // 新工单
      if (app_code == 'ticket-v4') {
        const getCount = (menus) => {
          service({
            url: statistics.url,
            method: "get"
          }).then(resp => {
            const { code, data } = resp
            if (code == 0 && data) {
              this.statisticsData = data
            }
          })
        }
        const ticketV4_menus = this.rawMenuData['ticket-v4'];
        const statistics = ticketV4_menus && ticketV4_menus.statistics
        if (statistics && statistics.enable && statistics.url) {
          clearInterval(this.refreshCountTimer)
          this.refreshCountTimer = null
          getCount(ticketV4_menus)
          this.refreshCountTimer = setInterval(() => {
            getCount(ticketV4_menus)
          }, statistics.interval * 60 * 1000)
        }
      }
    }
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/menu/index.vue